class ConfiguratorPopup {
    constructor() {
        this.$ = jQuery;
        this.pendingSelection = null;
        this.mediaCache = {};
        this.preloadingStarted = false;
        this.popupIsOpen = false;
        this.mobileBreakpoint = 1024;
        this.mobilePreviewActive = false;
        this.ajaxUrl = ajax.url;
        this.resizeTimeout = null; // Dodajemy throttling dla resize

        this.selectors = {
            accessoryOption: '.js-accessory-option',
            attributeUpdate: '.js-attribute-content-update',
            popup: '.js-accessory-popup',
            popupTitle: '.js-accessory-popup-title',
            popupImage: '.js-accessory-popup-image',
            popupDescription: '.js-accessory-popup-description',
            popupDetails: '.js-accessory-popup-details',
            popupClose: '.js-accessory-popup-close',
            popupConfirm: '.js-accessory-popup-confirm',
            popupContent: '.popup__content',
            configModalClose: '.js-config-modal-close',
            paramsContainer: '.configurator-modal__params',
            activeSelection: 'active-popup-selection',
            mobileWrapper: '.configurator-modal__mobile-preview',
            mobileMedia: '.configurator-modal__mobile-media',
            mobileHeader: '.configurator-modal__mobile-header',
            mobileDesc: '.configurator-modal__mobile-desc',
            mobileHeaderDesc: '.configurator-modal__mobile-header-desc',
            mobileDetailsToggle: '.js-mobile-details',
            mobileConfirm: '.js-configurator-mobile-confirm',
        };

        this.init();
    }

    init() {
        this.bindEvents();
        this.startPreloadingTimer();
        this.updateMobileConfirmState(false);
    }

    bindEvents() {
        const $ = this.$;

        // Event handlers
        $(document).on('click', this.selectors.accessoryOption, e =>
            this.handleAccessoryOptionClick(e)
        );
        $(document).on('click', this.selectors.attributeUpdate, e =>
            this.handleAttributeUpdateClick(e)
        );
        $(document).on('click', this.selectors.popupClose, e =>
            this.handlePopupClose(e)
        );
        $(document).on('click', this.selectors.popup, e =>
            this.handlePopupBackgroundClick(e)
        );
        $(document).on('click', this.selectors.popupConfirm, e =>
            this.handlePopupConfirm(e)
        );
        $(document).on('click', this.selectors.popupContent, e =>
            this.handlePopupContentClick(e)
        );
        $(document).on('keydown', e => this.handleKeydown(e));
        $(document).on('click', this.selectors.configModalClose, () => {
            this.handleConfigModalClose();
        });
        $(document).on('click', this.selectors.mobileDetailsToggle, e =>
            this.handleMobileDetailsToggle(e)
        );
        $(document).on('click', this.selectors.mobileConfirm, e =>
            this.handleMobileConfirm(e)
        );
        $(window).on('resize', () => this.handleWindowResize());
    }

    handleAccessoryOptionClick(e) {
        const $this = this.$(e.currentTarget);
        const popupDescription = $this.data('popup-description');
        const popupImageId = $this.data('popup-image');
        const popupVideoUrl = $this.data('popup-video-url');
        const popupVideoPoster = $this.data('popup-video-poster');
        const popupTitle = $this.data('name');
        const hasPopupContent =
            popupDescription || popupImageId || popupVideoUrl;

        if (hasPopupContent) {
            e.preventDefault();
            e.stopPropagation();
            this.setActiveSelection($this);

            if (this.isMobileView()) {
                this.pendingSelection = $this;
                this.populateMobilePreview({
                    title: popupTitle,
                    description: popupDescription,
                    imageId: popupImageId,
                    videoUrl: popupVideoUrl,
                    poster: popupVideoPoster,
                });
                return false;
            }

            const $popup = this.$(this.selectors.popup);
            $popup.find(this.selectors.popupTitle).text(popupTitle);
            this.loadPopupMedia({
                imageId: popupImageId,
                videoUrl: popupVideoUrl,
                poster: popupVideoPoster,
            });
            $popup
                .find(this.selectors.popupDescription)
                .html(popupDescription || '');
            this.positionPopup();
            this.openPopup($popup);
            return false;
        }

        this.handleOptionWithoutPopup($this);
    }

    isMobileView() {
        return window.innerWidth <= this.mobileBreakpoint;
    }

    populateMobilePreview({ title, description, imageId, videoUrl, poster }) {
        const $wrapper = this.$(this.selectors.mobileWrapper);
        if (!$wrapper.length) {
            return;
        }

        const $header = $wrapper.find(this.selectors.mobileHeader);
        const $desc = $wrapper.find(this.selectors.mobileDesc);
        const $descWrapper = $wrapper.find(this.selectors.mobileHeaderDesc);
        const $detailsToggle = $wrapper.find(
            this.selectors.mobileDetailsToggle
        );

        $wrapper.removeClass('is-hidden is-details-open');
        $header.text(title || '');
        $detailsToggle.attr('aria-expanded', 'false');
        $detailsToggle.removeClass('is-active');
        $descWrapper.removeClass('is-visible');

        if (description) {
            $desc.html(description);
            $descWrapper.removeClass('is-hidden');
            $detailsToggle.removeClass('is-hidden');
        } else {
            $desc.empty();
            $descWrapper.addClass('is-hidden');
            $detailsToggle.addClass('is-hidden');
        }

        this.loadMobileMedia({ imageId, videoUrl, poster });
        this.mobilePreviewActive = true;
        this.updateMobileConfirmState(true);
    }

    loadMobileMedia({ imageId, videoUrl, poster }) {
        const $media = this.$(this.selectors.mobileMedia);
        if (!$media.length) {
            return;
        }

        if (videoUrl) {
            this.renderVideoInto($media, videoUrl, poster, {
                muted: true,
                autoplay: true,
                loop: true,
            });
            return;
        }

        this.loadMobileImage(imageId);
    }

    loadMobileImage(imageId) {
        const $media = this.$(this.selectors.mobileMedia);
        if (!$media.length) {
            return;
        }

        if (!imageId || imageId === '0' || imageId === '') {
            $media.html('<div class="loading-state"><p>Brak mediów</p></div>');
            return;
        }

        const cacheKey = this.getMediaCacheKey('image', imageId);

        if (this.mediaCache[cacheKey]) {
            $media.html(this.mediaCache[cacheKey]);
            return;
        }

        $media.html(
            '<div class="loading-state"><p>Ładowanie obrazu...</p></div>'
        );

        this.$.post(this.ajaxUrl, {
            action: 'mda_get_attachment_image',
            attachment_id: imageId,
            size: 'full',
        })
            .done(response => {
                if (response.success) {
                    this.mediaCache[cacheKey] = response.data;
                    $media.html(response.data);
                } else {
                    $media.html(
                        '<div class="loading-state"><p>Brak mediów</p></div>'
                    );
                }
            })
            .fail(() => {
                $media.html(
                    '<div class="loading-state"><p>Błąd ładowania mediów</p></div>'
                );
            });
    }

    handleMobileDetailsToggle(e) {
        e.preventDefault();
        const $wrapper = this.$(this.selectors.mobileWrapper);
        if (!$wrapper.length) {
            return;
        }

        const $details = $wrapper.find(this.selectors.mobileHeaderDesc);
        if ($details.hasClass('is-hidden')) {
            return;
        }

        const isOpen = $wrapper.hasClass('is-details-open');
        const $toggle = this.$(e.currentTarget);

        $wrapper.toggleClass('is-details-open', !isOpen);
        $details.toggleClass('is-visible', !isOpen);
        $toggle.toggleClass('is-active', !isOpen);
        $toggle.attr('aria-expanded', String(!isOpen));
    }

    handleMobileConfirm(e) {
        e.preventDefault();
        if (!this.pendingSelection) {
            return;
        }

        this.applyPendingSelection();
        this.resetMobilePreview();
    }

    updateMobileConfirmState(isEnabled) {
        const $button = this.$(this.selectors.mobileConfirm);
        if (!$button.length) {
            return;
        }

        $button.prop('disabled', !isEnabled);
        $button.toggleClass('is-disabled', !isEnabled);
    }

    resetMobilePreview() {
        const $wrapper = this.$(this.selectors.mobileWrapper);
        if ($wrapper.length) {
            $wrapper.addClass('is-hidden').removeClass('is-details-open');
            $wrapper.find(this.selectors.mobileMedia).empty();
            $wrapper.find(this.selectors.mobileHeader).empty();
            $wrapper.find(this.selectors.mobileDesc).empty();
            $wrapper
                .find(this.selectors.mobileHeaderDesc)
                .removeClass('is-visible')
                .addClass('is-hidden');
            $wrapper
                .find(this.selectors.mobileDetailsToggle)
                .attr('aria-expanded', 'false')
                .removeClass('is-active')
                .addClass('is-hidden');
        }

        this.updateMobileConfirmState(false);
        this.mobilePreviewActive = false;
        this.clearActiveSelection();
        this.pendingSelection = null;
    }

    applyPendingSelection() {
        if (!this.pendingSelection) {
            return;
        }

        const updateClass = this.selectors.attributeUpdate.replace('.', '');
        this.pendingSelection.addClass(updateClass);
        this.pendingSelection.trigger('click');
        this.pendingSelection.removeClass(updateClass);
        this.pendingSelection = null;
    }

    handleAttributeUpdateClick(e) {
        if (this.popupIsOpen) {
            this.closePopup();
        }
    }

    handlePopupClose(e) {
        e.preventDefault();
        this.closePopup();
    }

    handlePopupBackgroundClick(e) {
        if (e.target === e.currentTarget) {
            this.closePopup();
        }
    }

    handlePopupConfirm(e) {
        e.preventDefault();
        this.applyPendingSelection();
        this.closePopup();
    }

    handlePopupContentClick(e) {
        e.stopPropagation();
    }

    handleKeydown(e) {
        if (e.key !== 'Escape') {
            return;
        }

        if (this.popupIsOpen) {
            this.closePopup();
        } else if (this.mobilePreviewActive) {
            this.resetMobilePreview();
        }
    }

    handleConfigModalClose() {
        if (this.popupIsOpen) {
            this.closePopup();
        }
        if (this.mobilePreviewActive) {
            this.resetMobilePreview();
        }
    }

    handleWindowResize() {
        // Throttling - wykonaj tylko po 100ms od ostatniego resize
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            const $popup = this.$(this.selectors.popup + ':first');
            if ($popup.is(':visible') && this.popupIsOpen) {
                this.positionPopup();
            }
            if (!this.isMobileView() && this.mobilePreviewActive) {
                this.resetMobilePreview();
            }
        }, 100);
    }

    cleanupPopupDuplicates() {
        const $allPopups = this.$(this.selectors.popup);
        if ($allPopups.length > 1) {
            // Zostaw tylko pierwszy popup, usuń resztę
            $allPopups.slice(1).remove();
            console.log(
                'Cleaned up',
                $allPopups.length - 1,
                'popup duplicates'
            );
        }
    }

    setActiveSelection($element) {
        this.$(
            this.selectors.paramsContainer +
                ' ' +
                this.selectors.accessoryOption
        ).removeClass(this.selectors.activeSelection);
        $element.addClass(this.selectors.activeSelection);
        this.pendingSelection = $element;
    }

    clearActiveSelection() {
        this.$(
            this.selectors.paramsContainer +
                ' ' +
                this.selectors.accessoryOption
        ).removeClass(this.selectors.activeSelection);
    }

    showPopup($element, description, imageId) {
        // Nie używamy już tej metody, logika przeniesiona do handleAccessoryOptionClick
    }

    closePopup() {
        const $popup = this.$(this.selectors.popup);
        $popup.stop(true, true).animate({ opacity: 0 }, 300, () => {
            $popup.css('display', 'none');
        });
        this.clearActiveSelection();
        this.pendingSelection = null;
        this.popupIsOpen = false;
    }

    openPopup($popup) {
        const isHidden = $popup.css('display') === 'none';
        $popup.stop(true, true);

        if (isHidden) {
            $popup
                .css({ display: 'flex', opacity: 0 })
                .animate({ opacity: 1 }, 300);
        } else {
            $popup.css('display', 'flex');
        }

        this.popupIsOpen = true;
    }

    handleOptionWithoutPopup($element) {
        if (this.popupIsOpen) {
            this.closePopup();
        }

        if (this.mobilePreviewActive) {
            this.resetMobilePreview();
        } else {
            this.clearActiveSelection();
        }

        $element.addClass(this.selectors.attributeUpdate.replace('.', ''));
        setTimeout(() => {
            $element.removeClass(
                this.selectors.attributeUpdate.replace('.', '')
            );
        }, 100);
    }

    loadPopupMedia({ imageId, videoUrl, poster }) {
        if (videoUrl) {
            this.renderVideoInto(this.selectors.popupImage, videoUrl, poster, {
                muted: false,
                autoplay: true,
                loop: true,
            });
            return;
        }

        this.loadPopupImage(imageId);
    }

    loadPopupImage(imageId) {
        if (!imageId || imageId === '0' || imageId === '') {
            this.$(this.selectors.popupImage).empty();
            return;
        }

        const cacheKey = this.getMediaCacheKey('image', imageId);

        if (this.mediaCache[cacheKey]) {
            console.log('Loading image from cache for ID:', imageId);
            this.$(this.selectors.popupImage).html(this.mediaCache[cacheKey]);
            return;
        }

        const $imageContainer = this.$(this.selectors.popupImage);

        if ($imageContainer.data('loading-id') === imageId) {
            console.log(
                'Image already loading, skipping request for ID:',
                imageId
            );
            return;
        }

        this.loadImageViaAjax(imageId);
    }

    loadImageViaAjax(imageId) {
        const $imageContainer = this.$(this.selectors.popupImage);
        const cacheKey = this.getMediaCacheKey('image', imageId);
        $imageContainer.data('loading-id', imageId);
        $imageContainer.html(
            '<div class="loading-state"><p>Ładowanie obrazu...</p></div>'
        );

        // Use same AJAX call as working version - no explicit JSON datatype
        this.$.post(this.ajaxUrl, {
            action: 'mda_get_attachment_image',
            attachment_id: imageId,
            size: 'full',
        })
            .done(response => {
                if (response.success) {
                    this.mediaCache[cacheKey] = response.data;
                    $imageContainer.html(response.data);
                } else {
                    const errorHtml =
                        '<div style="text-align:center; color:#999;"><p>Nie udało się załadować obrazu (ID: ' +
                        imageId +
                        ')</p></div>';
                    $imageContainer.html(errorHtml);
                }
                $imageContainer.removeData('loading-id');
            })
            .fail((xhr, status, error) => {
                const errorHtml =
                    '<div style="text-align:center; color:#999;"><p>Błąd połączenia podczas ładowania obrazu</p></div>';
                $imageContainer.html(errorHtml);
                $imageContainer.removeData('loading-id');
            });
    }

    getFallbackImageUrl(imageId) {
        // Try different WordPress attachment URL patterns
        const baseUrl = window.location.origin;
        return `${baseUrl}/wp-content/uploads/attachment-${imageId}.jpg`; // This is just a fallback, may not work
    }

    positionPopup() {
        const $popup = this.$(this.selectors.popup);
        this.positionForDesktop($popup);
    }

    positionForDesktop($popup) {
        const $body = this.$('body');

        // Sprawdź czy popup nie jest już w body
        if ($popup.parent().is('body')) {
            return; // Już jest w odpowiednim miejscu
        }

        // Usuń tylko duplikaty, nie aktualny popup
        $body.find(this.selectors.popup).not($popup).remove();

        // Przenieś popup tylko jeśli nie jest już w body
        $popup.detach().appendTo($body);
    }

    preloadPopupImages() {
        if (this.preloadingStarted) {
            console.log('Preloading already started, skipping...');
            return;
        }

        this.preloadingStarted = true;
        const imagesToPreload = this.collectImagesToPreload();

        imagesToPreload.forEach((imageId, index) => {
            setTimeout(() => {
                const cacheKey = this.getMediaCacheKey('image', imageId);
                if (!this.mediaCache[cacheKey]) {
                    this.preloadSingleImage(imageId);
                }
            }, index * 500);
        });
    }

    collectImagesToPreload() {
        const imagesToPreload = [];

        this.$(this.selectors.accessoryOption).each((index, element) => {
            const popupImageId = this.$(element).data('popup-image');
            if (
                popupImageId &&
                popupImageId !== '0' &&
                popupImageId !== '' &&
                !this.mediaCache[
                    this.getMediaCacheKey('image', popupImageId)
                ] &&
                imagesToPreload.indexOf(popupImageId) === -1
            ) {
                imagesToPreload.push(popupImageId);
            }
        });

        return imagesToPreload;
    }

    preloadSingleImage(imageId) {
        this.$.post(this.ajaxUrl, {
            action: 'mda_get_attachment_image',
            attachment_id: imageId,
            size: 'full',
        })
            .done(response => {
                if (response.success) {
                    const cacheKey = this.getMediaCacheKey('image', imageId);
                    this.mediaCache[cacheKey] = response.data;
                } else {
                    console.log(
                        'Failed to preload image ID:',
                        imageId,
                        response.data
                    );
                }
            })
            .fail(() => {
                console.log('AJAX failed for preload image ID:', imageId);
            });
    }

    startPreloadingTimer() {
        setTimeout(() => {
            this.preloadPopupImages();
        }, 3000);
    }

    renderVideoInto(target, videoUrl, poster = '', options = {}) {
        const $container = target && target.jquery ? target : this.$(target);
        if (!$container.length || !videoUrl) {
            return;
        }

        const cacheKey = this.getMediaCacheKey('video', videoUrl);

        if (this.mediaCache[cacheKey]) {
            $container.html(this.mediaCache[cacheKey]);
            return;
        }

        const attrs = ['preload="metadata"', 'playsinline'];

        if (options.autoplay) {
            attrs.push('autoplay');
        }
        if (options.loop) {
            attrs.push('loop');
        }
        if (options.muted) {
            attrs.push('muted');
        }
        if (poster) {
            attrs.push(`poster="${poster}"`);
        }

        const videoMarkup = `<video ${attrs.join(
            ' '
        )} ><source src="${videoUrl}" type="video/mp4"></video>`;
        this.mediaCache[cacheKey] = videoMarkup;
        $container.html(videoMarkup);
    }

    getMediaCacheKey(type, identifier) {
        return `${type}:${identifier}`;
    }
}
export default ConfiguratorPopup;
